<template>
  <v-app
    class='white'
    light
  >
    <v-content>
      <sHeader title='My Genetic Trust Complete'/>
      <section>
        <v-layout
          row
          wrap
          align-center
          class="my-12"
        >

          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout
                row
                align-center
              >
                <v-flex
                  xs12
                  md8
                >
                  <v-card

                    flat
                    class="transparent"
                  >

                    <v-card-text>

                      <p class='headline font-weight-regular'>
                        Responsible life planning means making sure your assets are in
                        order. Now you can do the same with your genetic health
                        history, including securely banking your DNA*.
                      </p>

                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-card
                    flat
                    class="transparent"
                  >
                    <v-card-text class="text-center">
                      <img src='../../assets/staticAsset/GSF_Sketch-Couple-Color-00.jpg' />
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex

                  xs12
                  md8
                >
                  <v-card

                    flat
                    class="transparent"
                  >

                    <v-card-text>
                      <p class="title font-weight-bold mainBlue">Process</p>
                      <p class='font-weight-regular title'>
                        Securing your genetic health history can be achieved in a few simple steps:
                      </p >
                      <li class='font-weight-regular subtitle-1'>Complete health and family history information</li>
                      <li class='font-weight-regular subtitle-1 mb-5'>Name your beneficiaries</li>
                      <p class='font-weight-regular title'>
                        Next, one of our certified genetic counselors will review your
                        information, identify any additional records that would be
                        useful, and pinpoint any indications that meet criteria for genetic
                        counseling or consideration of genetic testing.
                        </p>
                        <p class='font-weight-regular title'>
                          You and your named beneficiaries will be able to access your
                          genetic health history online through a secure HIPAA-compliant
                          portal.
                        </p>
                      <p class='font-weight-regular title'>
                      My Genetic Trust Complete allows for secure storage of your important health and family records and banked DNA. You can rest assured that your sensitive information will never be sold and will only be shared with your designated beneficiaries. You and your beneficiaries will be able to access your complete family health history and final My Genetic Trust report through a secure HIPAA-compliant portal at any time.
                      </p>
                      <p class='font-weight-regular subtitle-1'>*You and your beneficiaries will own your DNA; it is against our policies and ethics to sell DNA.</p>
                    </v-card-text>

                  </v-card>
                </v-flex>

                <v-flex
                  xs12
                  md4
                >
                <p class="title font-weight-bold mainBlue">My Genetic Trust Complete Details</p>
                  <v-card
                    :outlined='true'
                    class="green-border"
                  >
                    <v-card-text>
                      <p class='subtitle-1'>Guide for family history collection</p>
                       <v-divider class='featureCard' insert></v-divider>
                       <p class='subtitle-1'>Guide for medical record collection</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1'> Family Health Tree Worksheet</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1'>Genetic counselor reviews medical and family history</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1'>Generate a My Genetic Trust report</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1'>Storage of medical and family history</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1'>DNA Banking</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1'>Expert support</p>
                    </v-card-text>
                  </v-card>

                </v-flex>
                <v-flex
                 xs12
                  md8>
                  <v-card  flat class="transparent">
                    <v-card-text>
                      <p class="title font-weight-bold mainBlue">Annual Updates</p>
                        <p class='font-weight-regular title'>Your annual subscription will allow you to add any new family members, new genetic information, or health history at any time during your subscription year.</p>

                       <p class="title font-weight-bold mainBlue">Pricing</p>
                       <p class='font-weight-regular title'>Your package includes one year of updates. If you wish to continue services after your initial year, you will need to sign up for an annual update subscription plan.</p>                       
                       <v-layout
                          row
                            wrap
                            align-center
                            class="my-12"
                          >
                          <v-flex
                            xs6 >
                            <p class="title font-weight-bold mainBlue">Individual</p>
                          </v-flex>
                            <v-flex
                            xs6 >
                            <p class="title font-weight-bold mainBlue">Couple (Two Adults)</p>
                          </v-flex>
                           <v-flex
                            xs12 >
                             <v-divider class='mt-n8' insert></v-divider>
                          </v-flex>
                           <v-flex
                           class='mt-n10'
                            xs6 >
                            <p class="title">$599</p>
                            <p class="title  font-weight-bold mainBlue">Annual Update Subscription</p>
                            <p class="title">$120</p>
                          </v-flex>
                            <v-flex
                            class='mt-n10'
                            xs6 >
                            <p class="title">$899</p>
                            <p class="title font-weight-bold mainBlue">Annual Update Subscription</p>
                            <p class="title">$180</p>
                          </v-flex>
                       </v-layout>

                           <p class='subtitle-1'>You can cancel your subscription at any time and will be provided your
                        <span class='font-weight-black'>My Genetic Trust Report</span> and all documentation we have on file at time
                        of cancellation.</p>

                  <signupButton
                    :dark='true'
                    :large='true'
                    color='#399342'
                    :plan='1'
                    buttonText="Sign Up for Genetic Trust Complete"/>
                   <!-- <v-btn href="Signup" large>Sign Up for Genetic Trust Complete</v-btn> -->
                   </v-card-text>
                  </v-card>
                </v-flex>
               <v-flex
                 xs12
                  md4

                  >
                    <v-card  flat class="transparent">
                    <v-card-text>
                    <p class="mt-7 title font-weight-bold mainBlue" >View our Other Plans</p>
                  <a class="font-weight-regular title  green--text" href="/public/plus">My Genetic Trust Plus</a>
                  <br />
                  <a class="font-weight-regular title  green--text" href="/public/concierge">My Genetic Trust Concierge</a>
                     </v-card-text>
                  </v-card>
               </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <!-- footer section -->
      <v-footer
        class='footer white'
        color="darken-2"
      >
      <sfooter />
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>

import sHeader from "../../components/staticPage/Header"
import signupButton from "../../components/Signup"
import sfooter from "../../components/staticPage/Footer"
export default {
    components : {
    sfooter,
    signupButton,
    sHeader
  },
  mounted () {
  }
}
</script>

<style scoped>
.mainBlue {
  color: #399342;
}
.featureCard{
  margin-bottom : 1%
}
p {
font-weight : bold
}
</style>
